module.exports = __webpack_public_path__ + "img/white.f19e6ba7.webp";